<template>
  <div class="container">
    <h5>{{ t('imageFrequencyToSize') }}</h5>
    <p>
      {{ t('storageSpaceNote') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('imageSize')"
          v-model.number="imageSizeMB"
          :unit="t('mb')"
        />
        <FixedUnitInput
          :input-label="t('captureInterval')"
          v-model.number="captureInterval"
          :unit="t('minutes')"
        />
      </div>
      <div class="col-sm">
        <GenericOutput
          :output-label="t('sizePerDay')"
          :number="sizePerDay"
          :conversion-factors="ConversionFactors.basicData"
          show-splitter="false"
        />
        <GenericOutput
          :output-label="t('sizePerWeek')"
          :number="sizePerWeek"
          :conversion-factors="ConversionFactors.basicData"
          show-splitter="false"
        />
        <GenericOutput
          :output-label="t('sizePerMonth')"
          :number="sizePerMonth"
          :conversion-factors="ConversionFactors.basicData"
          show-splitter="false"
        />
        <GenericOutput
          :output-label="t('sizePerFourMonths')"
          :number="sizePerFourMonths"
          :conversion-factors="ConversionFactors.basicData"
          show-splitter="false"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import GenericOutput from '../inputs/GenericOutput.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  import { defaultRound } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FixedUnitInput,
      GenericOutput,
    },
    setup() {
      const imageSizeMB = ref(1.8);
      const captureInterval = ref(10);

      const { t } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

       
  
      const sizePerDay = computed(() => {
        const minutesInDay = 1440;
        const photosPerDay = minutesInDay / captureInterval.value;
        return defaultRound(photosPerDay * imageSizeMB.value);
      });
  
      const sizePerWeek = computed(() => {
        return defaultRound(sizePerDay.value * 7);
      });
  
      const sizePerMonth = computed(() => {
        return defaultRound(sizePerDay.value * 31);
      });
  
      const sizePerFourMonths = computed(() => {
        return defaultRound(sizePerDay.value * 124);
      });
  
      return {
        imageSizeMB,
        captureInterval,
        sizePerDay,
        sizePerWeek,
        sizePerMonth,
        sizePerFourMonths,
        ConversionFactors,
        t: translations.t
      };
    },
  };
  </script>
  